(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["melly-giveaway"] && !Shopify.designMode) return;
  try {
    
function initMellyGiveaway(){const modal=document.getElementById('MellyGiveaway');if(!modal||modal.dataset.ready)return;modal.dataset.ready='true';const key='melly-giveaway-dismissed';const month=modal.querySelector('[data-giveaway-month]');if(month){const parts=new Intl.DateTimeFormat('en-CA',{timeZone:'Europe/Berlin',year:'numeric',month:'2-digit'}).formatToParts(new Date());month.value=parts.find(p=>p.type==='year').value+'-'+parts.find(p=>p.type==='month').value}const open=()=>{if(!modal.open){modal.showModal();modal.querySelector('[data-giveaway-close]')?.focus()}};const dismiss=()=>{modal.close();try{sessionStorage.setItem(key,'yes')}catch{}};document.querySelectorAll('[data-giveaway-open]').forEach(button=>button.addEventListener('click',open));modal.querySelector('[data-giveaway-close]').addEventListener('click',dismiss);modal.addEventListener('cancel',()=>{try{sessionStorage.setItem(key,'yes')}catch{}});modal.addEventListener('click',event=>{if(event.target!==modal)return;const r=modal.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)dismiss()});if(modal.querySelector('[data-giveaway-success],[data-giveaway-error]')){open();return}let dismissed=false;try{dismissed=sessionStorage.getItem(key)==='yes'}catch{}if(!dismissed)setTimeout(()=>{if(document.visibilityState==='visible')open()},14000)}initMellyGiveaway();document.addEventListener('shopify:section:load',initMellyGiveaway);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["melly-header"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click',event=>{document.querySelectorAll('.melly-mobile-menu[open]').forEach(menu=>{if(!menu.contains(event.target)||event.target.closest('a'))menu.open=false})});
document.addEventListener('keydown',event=>{if(event.key==='Escape')document.querySelectorAll('.melly-mobile-menu[open]').forEach(menu=>{menu.open=false;menu.querySelector('summary').focus()})});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["melly-storefront"] && !Shopify.designMode) return;
  try {
    
function initMellyShelves(){document.querySelectorAll('.melly-products').forEach(shelf=>{if(shelf.dataset.filtersReady)return;shelf.dataset.filtersReady='true';const bar=shelf.querySelector('.melly-filterbar');if(!bar)return;bar.hidden=false;bar.addEventListener('click',event=>{const button=event.target.closest('[data-scent-filter]');if(!button)return;const category=button.dataset.scentFilter;bar.querySelectorAll('button').forEach(item=>item.setAttribute('aria-pressed',String(item===button)));let count=0;shelf.querySelectorAll('[data-scent-family]').forEach(card=>{card.hidden=category!=='all'&&card.dataset.scentFamily!==category;if(!card.hidden)count++});shelf.querySelector('.melly-filter-status').textContent=button.textContent.trim()+': '+count+' '+shelf.dataset.designLabel})})}
initMellyShelves();document.addEventListener('shopify:section:load',initMellyShelves);window.addEventListener('hashchange',()=>{if(location.hash.startsWith('#melly-scent-'))document.querySelectorAll('[data-scent-filter="all"]').forEach(button=>button.click())});

  } catch(e) { console.error(e); }
})();
})();
